import { useStorage } from "opendash";

export function useFavorites() {
  return useStorage<string[]>("user", "recipes:favorites", []);
}
